import theme from "theme";
import {
  Add,
  ArrowForward,
  Remove,
} from "@mui/icons-material"
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material"
import Button from "components/atoms/Button";
import { useState } from "react"
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const FAQs = () => {
  const {t}=useTranslation()
  const navigate=useNavigate()
  const [expandedFaq, setExpandedFaq] = useState<string | false>(false)
  const handleFaqChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpandedFaq(isExpanded ? panel : false)
  }

  const faqs = [
    {
      id: "faq1",
      question: t("eventFaqs.event_type.question"),
      answer: t("eventFaqs.event_type.answer"),
    },
    {
      id: "faq2",
      question: t("eventFaqs.Booking_time.question"),
      answer: t("eventFaqs.Booking_time.answer"),
    },
    {
      id: "faq3",
      question: t("eventFaqs.professional_drivers.question"),
      answer: t("eventFaqs.professional_drivers.answer"),
    },
    {
      id: "faq4",
      question: t("eventFaqs.support.question"),
      answer: t("eventFaqs.support.answer"),
    },
    {
      id: "faq5",
      question: t("eventFaqs.safety_measure.question"),
      answer: t("eventFaqs.safety_measure.answer"),
    },
    {
      id: "faq6",
      question: t("eventFaqs.fees.question"),
      answer: t("eventFaqs.fees.answer"),
    },
  ];
  
  
  return (
    <>
      <Box sx={{ mb: 10, mt: 15 }}>
          <Box sx={{ textAlign: "Left", mb: 6 }}>
      <Box sx={{ textAlign: "center", mb: { xs: 8, md: 10 } }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 3 }}>
        <Box sx={{ width: 60, height: 2, bgcolor: "#FFCD00", mr: 2 }} />
        <Box
          sx={{
            bgcolor: "rgba(82, 10, 118, 0.1)",
            color:theme.palette.primary.contrastText,
            px: 3,
            py: 1,
            borderRadius: 5,
            fontWeight: 600,
            fontSize: "0.9rem",
          }}
        >
{t("faqs")}     
   </Box>
        <Box sx={{ width: 60, height: 2, bgcolor: "#FFCD00", ml: 2 }} />
      </Box>

      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: "2.5rem", md: "2.5rem" },
          color:theme.palette.primary.contrastText,
          mb: 4,
          fontWeight: 800,
          lineHeight: 1.2,
        }}
      >
       {t("Frequently Asked Questions")}
      </Typography>

      <Typography
        variant="h6"
        sx={{
          color: "text.secondary",
          fontWeight: 400,
          lineHeight: 1.7,
          fontSize: "1rem",
          maxWidth: 700,
          mx: "auto",
        }}
      >
        {t("faqDetails")}
      </Typography>
    </Box>
          </Box>

          {/* Two-column layout for FAQs */}
          <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 4 }}>
            {/* Left column */}
            <Box sx={{ flex: 1 }}>
              {faqs.slice(0, 3).map((faq) => (
                <Accordion
                  key={faq.id}
                  expanded={expandedFaq === faq.id}
                  onChange={handleFaqChange(faq.id)}
                  sx={{
                    mb: 2,
                    boxShadow: "none",
                    border: "1px solid rgba(0,0,0,0.08)",
                    borderLeft: `4px solid ${theme.palette.secondary.contrastText}`,
                    borderRadius: "12px !important",
                    overflow: "hidden",
                    "&:before": {
                      display: "none",
                    },
                    "&.Mui-expanded": {
                      margin: "0 0 16px 0",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      expandedFaq === faq.id ? (
                        <Remove sx={{ color: theme.palette.secondary.contrastText }} />
                      ) : (
                        <Add sx={{ color: theme.palette.secondary.contrastText }} />
                      )
                    }
                    sx={{
                      backgroundColor: expandedFaq === faq.id ? "rgba(142, 36, 170, 0.04)" : "white",
                      borderRadius: "12px",
                      "&.Mui-expanded": {
                        borderBottom: "1px solid rgba(0,0,0,0.08)",
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                      },
                      "& .MuiAccordionSummary-content": {
                        margin: "12px 0",
                      },
                      paddingLeft: "20px",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "600",
                        fontSize: "1.1rem",
                        color: expandedFaq === faq.id ? theme.palette.secondary.contrastText : "#333",
                      }}
                    >
                      {faq.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      backgroundColor: "rgba(142, 36, 170, 0.02)",
                      p: 3,
                      borderBottomLeftRadius: "12px",
                      borderBottomRightRadius: "12px",
                    }}
                  >
                    <Typography variant="body1" sx={{ color: "#333", lineHeight: 1.7 }}>
                      {faq.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>

            {/* Right column */}
            <Box sx={{ flex: 1 }}>
              {faqs.slice(3, 6).map((faq) => (
                <Accordion
                  key={faq.id}
                  expanded={expandedFaq === faq.id}
                  onChange={handleFaqChange(faq.id)}
                  sx={{
                    mb: 2,
                    boxShadow: "none",
                    border: "1px solid rgba(0,0,0,0.08)",
                    borderLeft: `4px solid ${theme.palette.secondary.contrastText}`,
                    borderRadius: "12px !important",
                    overflow: "hidden",
                    "&:before": {
                      display: "none",
                    },
                    "&.Mui-expanded": {
                      margin: "0 0 16px 0",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      expandedFaq === faq.id ? (
                        <Remove sx={{ color: theme.palette.secondary.contrastText }} />
                      ) : (
                        <Add sx={{ color: theme.palette.secondary.contrastText }} />
                      )
                    }
                    sx={{
                      backgroundColor: expandedFaq === faq.id ? "rgba(142, 36, 170, 0.04)" : "white",
                      borderRadius: "12px",
                      "&.Mui-expanded": {
                        borderBottom: "1px solid rgba(0,0,0,0.08)",
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                      },
                      "& .MuiAccordionSummary-content": {
                        margin: "12px 0",
                      },
                      paddingLeft: "20px",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "600",
                        fontSize: "1.1rem",
                        color: expandedFaq === faq.id ? theme.palette.secondary.contrastText : "#333",
                      }}
                    >
                      {faq.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      backgroundColor: "rgba(142, 36, 170, 0.02)",
                      p: 3,
                      borderBottomLeftRadius: "12px",
                      borderBottomRightRadius: "12px",
                    }}
                  >
                    <Typography variant="body1" sx={{ color: "#333", lineHeight: 1.7 }}>
                      {faq.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </Box>
        </Box>
    </>
  );
};

export default FAQs;
